import styled from 'styled-components'

export const Container = styled.div`
  position: absolute;
  right: 40px;
  top: 16px;
`